import { getAxiosInstance } from "../../../api";

export const exportCashReceipt = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/delivery/cash-receipt/export`,
      params,
      { responseType: "blob" },
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
